import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export default function AnnouncementBar() {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);

  const announcements = [
    {
      icon: '⚖️',
      text: 'NEW: The Luevano Standard - California\'s Blueprint for High-Trust AI',
      link: '/luevano-standard'
    },
    {
      icon: '📢',
      text: 'NEW: State of AI Safety 2025 Report - Critical Analysis of Current AI Governance',
      link: '/state-of-ai-2025'
    },
    {
      icon: '🔴',
      text: 'BREAKING: Open Letter to Governor Newsom on AI Accountability Framework',
      link: '/open-letter-governor-newsom'
    },
    {
      icon: '📊',
      text: 'FEATURED: Constitutional AI Engineering Standard - A New Paradigm for AI Safety',
      link: '/cai-engineering-standard'
    },
    {
      icon: '⚡',
      text: 'LATEST: AI Liability White Paper - Legal Framework for Algorithmic Accountability',
      link: '/ai-liability'
    },
    {
      icon: '🎯',
      text: 'ESSENTIAL: The Survival Imperative - Why AI Safety Cannot Wait',
      link: '/survival-imperative'
    },
    {
      icon: '📖',
      text: 'NEW RELEASE: Book Proposal - Comprehensive Guide to Constitutional AI Design',
      link: '/book-proposal'
    }
  ];

  if (!isVisible) return null;

  const handleAnnouncementClick = (link) => {
    if (window.location.pathname === link) {
      // If already on the page, scroll to top smoothly
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Navigate to the page
      navigate(link);
    }
  };

  return (
    <div className="bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 text-white relative overflow-hidden">
      <div className="flex items-center h-12">
        <div className="animate-scroll flex items-center whitespace-nowrap">
          {/* Duplicate announcements for seamless loop */}
          {[...announcements, ...announcements, ...announcements].map((announcement, index) => (
            <button
              key={index}
              onClick={() => handleAnnouncementClick(announcement.link)}
              className="inline-flex items-center gap-2 px-8 hover:text-blue-200 transition-colors cursor-pointer"
            >
              <span className="text-lg">{announcement.icon}</span>
              <span className="font-medium text-sm">{announcement.text}</span>
              <span className="text-blue-300 mx-4">•</span>
            </button>
          ))}
        </div>
      </div>
      
      {/* Close button */}
      <button
        onClick={() => setIsVisible(false)}
        className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center hover:bg-blue-700 rounded-full transition-colors cursor-pointer"
        aria-label="Close announcement bar"
      >
        <i className="ri-close-line text-lg"></i>
      </button>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }
        
        .animate-scroll {
          animation: scroll 60s linear infinite;
        }
        
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}
